"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceSupportsIoTVFeature = exports.LoRaDevices = void 0;
const DeviceTypesEnum_1 = require("./DeviceTypesEnum");
const debug = false;
/**
 * POC for revised DeviceTypes to address enum issue
 *
 */
const filterEnumForwardEntries = (enumObj) => {
    return Object.fromEntries(Object.entries(enumObj).filter(([key]) => isNaN(Number(key))));
};
exports.LoRaDevices = {
    ...filterEnumForwardEntries(DeviceTypesEnum_1.DeviceTypes),
    XTeL: 0x2a,
};
// const x: LoRaDeviceTypeValue = 999 -> Type '999' is not assignable to type 'LoRaDeviceTypeValue'.ts(2322)
const y = 0x24; // allowed
const iotvDeviceFeatureSupport = {
    VesselSensor: {},
    ElsysSensor: {},
    HiveSafe: {},
    ValveAct: {
        '451.x': {
            ASF: true,
            DLCnt: true,
        },
        '451.y': {
            ASF: true,
            DLCnt: true,
        }
    },
    AgriTel: {},
    RoveTel: {
        '2.28': {
            ASF: true,
            DLCnt: true,
        },
    },
    RangeTel: {},
    TakeFlowMeter: {},
    AngleTel: {
        '451.x': {
            ASF: true,
            DLCnt: true,
        },
    },
    GenericSensor: {},
    EffluentTracker: {},
    VibeTel: {},
    SoilMoisture: {},
    IsolationValve: {},
    SenseTel: {},
    PowerAct: {},
    ThirdParty: {},
    XTeL: {},
};
const deviceSupportsIoTVFeature = ({ device, feature }) => {
    const { deviceType, firmwareLevel } = device;
    const deviceTypeKey = Object.keys(exports.LoRaDevices).find((key) => exports.LoRaDevices[key] === deviceType);
    if (!firmwareLevel) {
        debug && console.warn(`No firmware level provided for device type ${deviceTypeKey}, cannot determine feature support`);
        return false;
    }
    if (!deviceTypeKey) {
        debug && console.warn(`Device type ${deviceType} not found in LoRaDevices`);
        return false;
    }
    const supportedFeatures = iotvDeviceFeatureSupport[deviceTypeKey]?.[firmwareLevel];
    if (!supportedFeatures) {
        debug && console.warn(`Firmware level ${firmwareLevel} not found for device type ${deviceTypeKey}`);
        return false;
    }
    return supportedFeatures[feature] ?? false;
};
exports.deviceSupportsIoTVFeature = deviceSupportsIoTVFeature;
